export default __webpack_public_path__ + "static/media/slider2.a6e435de.png";